import React, { useState } from 'react';

import Button from 'common/components/Button';
import PropTypes from '../../propTypes';
import { TranslatedMessage } from 'common/components/Intl';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from '../../messages';
import RadioButtonGroup from 'common/components/Form/RadioButtonGroup';

const ConfirmationModalContent = props => {
  const [selectedConfirmation, setConfirmation] = useState('');

  const handleRadioSelect = event => {
    setConfirmation(event.target.value);
  };

  const handleConfirm = () => {
    if (selectedConfirmation === 'confirm') {
      props.onConfirm();
    } else {
      props.onClose();
    }
  };

  const renderTitle = () => {
    return props.showNewConfirmationModal ? (
      <TranslatedMessage id={'age_verification.confirmation_modal.new_title'} />
    ) : (
      <TranslatedMessage id={m.CONFIRMATION_MODAL_TITLE} />
    );
  };

  const renderRadioButtons = () => {
    if (props.showNewConfirmationModal) {
      return (
        <div className="row">
          <div className="col-xs-12">
            <RadioButtonGroup
              onChange={handleRadioSelect}
              defaultValue=""
              name="data-match-confirmation"
              radioButtonProps={[
                {
                  text: (
                    <TranslatedMessage
                      id={'age_verification.confirmation_modal.confirm_text'}
                    />
                  ),
                  value: 'confirm',
                },
                {
                  text: (
                    <TranslatedMessage
                      id={'age_verification.confirmation_modal.cancel_text'}
                    />
                  ),
                  value: 'cancel',
                },
              ]}
            />
          </div>
        </div>
      );
    }
  };

  const renderButtons = () => {
    if (props.showNewConfirmationModal) {
      return (
        <div className="row">
          <div className="col-xs-12">
            <Button
              onClick={handleConfirm}
              id="confirm-button"
              className="ConfirmationModal__Button"
              disabled={selectedConfirmation === ''}
            >
              <TranslatedMessage id={m.CONFIRM} />
            </Button>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <Button
            onClick={props.onClose}
            className="ConfirmationModal__Button button--outline"
          >
            <TranslatedMessage id={m.CANCEL} />
          </Button>
        </div>
        <div className="col-xs-12 col-sm-6">
          <Button
            onClick={props.onConfirm}
            id="confirm"
            className="ConfirmationModal__Button"
          >
            <TranslatedMessage id={m.CONFIRM} />
          </Button>
        </div>
      </div>
    );
  };

  const containerClass = props.showNewConfirmationModal
    ? 'ConfirmationModal__content-v2'
    : 'ConfirmationModal__content';

  return (
    <div className={containerClass}>
      <div className="row">
        <div className="col-xs-12">
          <h3>{renderTitle()}</h3>
          <p className="text-body">
            <TranslatedMessage id={m.CONFIRMATION_MODAL_DESCRIPTION} />
          </p>
        </div>
        <div className="col-xs-12 col-sm-6">
          <div className="ConfirmationModal__data">
            <TranslatedMessage
              className="text--body--small"
              id={m.NAME_TITLE}
            />
            <div className="text--body fs-block">{props.legalName}</div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6">
          <div className="ConfirmationModal__data">
            <TranslatedMessage className="text--body--small" id={m.DOB_TITLE} />
            <div className="text--body fs-block">{props.formattedDob}</div>
          </div>
        </div>
      </div>
      {renderRadioButtons()}
      {renderButtons()}
      <p className="text--body--small">
        <TranslatedMessage id={m.CONFIRMATION_MODAL_DISCLAIMER} />
      </p>
    </div>
  );
};

ConfirmationModalContent.propTypes = {
  legalName: PropTypes.string.isRequired,
  formattedDob: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  showNewConfirmationModal: PropTypes.bool.isRequired,
};

ConfirmationModalContent.defaultProps = {
  showNewConfirmationModal: false,
};

export default ConfirmationModalContent;
